<template>
	<v-app>
		<div id="app">
			<NavbarHeader />
			<main id="site-content">
				<router-view />
			</main>
		</div>
	</v-app>
</template>

<script>
import NavbarHeader from '@/components/NavHeader';

export default {
	name: 'app',
	components: {
		NavbarHeader,
	},
	apollo: {
		prefetchMoments: {
			query: require('@/graphql/queries/prefetchMoments.gql'),
			skip() {
				return !this.$repo.auth.isLoggedIn();
			},
			pollInterval: 600000,
		},
	},
	mounted() {
		this.$repo.ref.getReference().then((ref) => {
			this.$store.commit('setRef', ref);
		});
	},
};
</script>

<style lang="scss">
#app.theme--light.v-application {
	background-image: url(assets/images/bg-dashboard.jpg);
}
#site-content {
	width: 100%;
	margin-top: 60px;
}

@media only screen and (min-width: 1200px) {
	.sidebar-expanded .content-wrapper {
		padding-left: 350px;
	}
}
</style>
